import { useQuery } from '@apollo/react-hooks';
import { useUser } from '../../useUser';
import { USE_ADDRESSES_QUERY, UseAddressesQuery } from './useAddressesQuery.rest';

export const useAddressesQuery = () => {
  const {
    user: { accessToken }
  } = useUser();
  const { data, loading, error } = useQuery<UseAddressesQuery>(USE_ADDRESSES_QUERY, {
    skip: !accessToken
  });

  return { data: data?.useAddresses.data || [], loading, error };
};
